import { Block, Typography } from '@aloft/toolkit-sui'
import { BooleanSelect, Row } from '../../../FilterDrawer/index';
import { StringSelect } from '../../../FilterDrawer/StringSelect.tsx';
import { Td } from '../../../table.tsx';
import { getEnumOptions } from './getEnumOptions.ts';
import { FilterInputFields } from './FilterInputFields.tsx';
import { useWatch } from 'react-hook-form';
import { RecommendCompsFormOutput, RecommendCompsFormSchema } from '../../types.ts';
import { filterHasValue } from '../../utils/filterHasValue.ts';
import { useZodFormContext } from '../../../../hooks/useZodForm.ts';

export const FilterRow = ({
  label,
  subjectValue,
  fieldName,
  includeMatchCriteria,
  inputType,
  unitName,
  includeClearButton,
  onClear,
}: {
  label: string;
  subjectValue?: string;
  fieldName: string;
  includeMatchCriteria: boolean;
  inputType: 'select' | 'boolean' | 'unit' | 'date' | 'price' | 'area';
  unitName?: string;
  includeClearButton?: boolean;
  onClear?: () => void;
}) => {
  const matchCriteriaFieldName = includeMatchCriteria ? `search.matchCriteria.${fieldName}` : undefined;
  const valueFieldName = `search.filters.${fieldName}`;
  const { control } = useZodFormContext<RecommendCompsFormSchema>();
  const value = useWatch({
    name: valueFieldName as keyof RecommendCompsFormOutput,
    control,
  });

  return (
    <Row label={label} includeClearButton={includeClearButton && filterHasValue(value)} onClear={onClear}>
      {matchCriteriaFieldName ? (
        <StringSelect
          name={matchCriteriaFieldName}
          options={getEnumOptions({
            name: matchCriteriaFieldName,
          })}
          colSpan={1}
        />
      ) : (
        <Td colSpan={1} />
      )}
      {inputType === 'select' && (
        <StringSelect
          name={valueFieldName}
          options={getEnumOptions({
            name: valueFieldName,
          })}
          placeholder="All"
        />
      )}
      {inputType === 'boolean' && (
        <BooleanSelect
          name={valueFieldName}
        />
      )}
      {['unit', 'date', 'price', 'area'].includes(inputType) && (
        <FilterInputFields
          name={fieldName as any}
          type={inputType as any}
          unitName={unitName}
        />
      )}
      <Td colSpan={1}>
        <Block padding="0 5px">
          <Typography variant="body1" color="textPrimary">
            {subjectValue ?? '-'}
          </Typography>
        </Block>
      </Td>
    </Row>
  )
}
